import {Repository, createRepository} from '@/repositories/Base/Repository'

class ImportRepository extends Repository {
    endpoint = 'loinc/exams/to'

    cleanAll(params) {
        return this.$axios.delete(`${this.endpoint}/import/do/clean`, params)
    }

    import(params) {
        return this.$axios.post(`${this.endpoint}/import`, params)
    }

    fetchAllCreated(params) {
        return this.$axios.get(`${this.endpoint}/create`, {params})
    }

    postCreated(params) {
        return this.$axios.post(`${this.endpoint}/create`, params)
    }

    fetchAllUpdated(params) {
        return this.$axios.get(`${this.endpoint}/update`, {params})
    }

    postUpdated(params) {
        return this.$axios.post(`${this.endpoint}/update`, params)
    }
}

export default new ImportRepository()

export const create = createRepository(ImportRepository)
